import { useSelector } from 'react-redux';
import Link from 'next/link';
import React from 'react';
import { Event, SPORT_CATEGORIES } from '@root/src/types';
import useEventInfo from '@root/src/hooks/useEventInfo';
import getRoute from '@services/routeList';
import { selectEventById } from '@features/eventList/slices/eventListServerSliceState';
import { EventCardRaw } from '@features/eventList/components/EventCard/index';

interface EventCardForEventsListProps {
  eventID: number;
  className?: string;
}
export const EventCardForEventsList = ({
  eventID,
  className,
}: EventCardForEventsListProps) => {
  const event = useSelector(selectEventById(eventID)) as Event;
  const { generateTags } = useEventInfo(event);

  return (
    <div>
      <Link href={getRoute.events(event.slug).description()}>
        <a>
          <EventCardRaw
            className={className}
            sportCategory={event.sportCategory ?? SPORT_CATEGORIES.other}
            name={event.name}
            dateFrom={event.dateFrom}
            dateTo={event.dateTo}
            date={event.date}
            location={event.location}
            site={event.site}
            eventType={event.eventType}
            tags={generateTags()}
          />
        </a>
      </Link>
    </div>
  );
};
